import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { CrossSVG } from '../svg/cross.svg';

const CrossIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <CrossSVG/>
    </div>
  );
};

export { CrossIcon };
